import axios, { type CreateAxiosDefaults } from "axios";

const classicOptions: CreateAxiosDefaults = {
  baseURL: process.env.NEXT_PUBLIC_BASE_URL || "http://localhost:3000",
  headers: {
    "Content-Type": "application/json",
  },

  withCredentials: true, // Важно для отправки кук даже при прямом запросе
  paramsSerializer: {
    indexes: true,
  },
};

const proxyOptions: CreateAxiosDefaults = {
  baseURL: process.env.NEXT_PUBLIC_FRONT_URL || "http://localhost:3001", // URL фронтенда
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // Важно для отправки кук через прокси
  paramsSerializer: {
    indexes: true,
  },
};

// Опции для Google API
const googleOptions: CreateAxiosDefaults = {
  baseURL: process.env.NEXT_PUBLIC_GOOGLE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
};

const axiosProxy = axios.create(proxyOptions);
const axiosClassic = axios.create(classicOptions);
const axiosWithAuth = axios.create(classicOptions);
const axiosWithGoogleAuth = axios.create(googleOptions);

export { axiosClassic, axiosProxy, axiosWithAuth, axiosWithGoogleAuth };
